import { gql } from '@apollo/client'

export const getAllUsers = gql`
    query GetAllUsers($pageSize: Int, $page: Int, $rcUserId: String) {
        getAllUsers(pageSize: $pageSize, page: $page, rcUserId: $rcUserId) {
            users {
                id
                createdAt
                updatedAt
                email
                role
                appleSub
                googleSub
                isAgreementChecked
                premiumExpiryDate
                fcmId
                rcUserId
                store
                totalCredit {
                    dailyCredit
                    total
                }
                usedCreditCount
                isPremium
            }
            totalCount
        }
    }
`

export const getUser = gql`
    query GetUser($userId: String!) {
        getUser(userId: $userId) {
            id
            createdAt
            updatedAt
            email
            role
            appleSub
            googleSub
            isAgreementChecked
            premiumExpiryDate
            fcmId
            rcUserId
            store
            totalCredit {
                total
                dailyCredit
            }
            sets {
                id
                name
                type
                createdAt
                images {
                    url
                }
                videos {
                    id
                    thumbnailUrl
                }
            }
            models {
                id
                name
                image
                status
                version
                createdAt
            }
            usedCreditCount
            isPremium
        }
    }
`

export const getAllvideos = gql`
    query GetAllVideos($pageSize: Int, $page: Int) {
        getAllVideos(pageSize: $pageSize, page: $page) {
            totalCount
            videos {
                id
                createdAt
                updatedAt
                taskId
                model
                url
                status
                prompt
                category
                thumbnailUrl
                title
                motionScore
                style
                progressRatio
                aspectRatio
                upScale
                inputImageUrl
                errorReason
            }
        }
    }
`
export const getVideo = gql`
    query GetVideo($videoId: String!) {
        getVideo(videoId: $videoId) {
            id
            createdAt
            updatedAt
            taskId
            userId
            model
            url
            status
            prompt
            category
            thumbnailUrl
            title
            motionScore
            style
            progressRatio
            aspectRatio
            upScale
            inputImageUrl
            errorReason
        }
    }
`

export const getAllCreditsAdmin = gql`
    query getAllCreditsAdmin {
        getAllCredits {
            amount
            rcEventId
            id
            user {
                id
                email
            }
            date
        }
    }
`
export const getHomePageVideos = gql`
    query GetHomePageVideos {
        getHomePageVideos {
            category
            createdAt
            id
            motionScore
            progressRatio
            prompt
            status
            style
            taskId
            thumbnailUrl
            title
            updatedAt
            url
        }
    }
`
export const getAllStyles = gql`
    query GetAllStylesAdmin($pageSize: Int, $page: Int, $name: String) {
    getAllStylesAdmin(pageSize: $pageSize, page: $page, name: $name) {
        styles {
        id
        name
        banner
        designType
        rowNumber
        toolType
        isPublic
        videoUrl
        gifUrl
        webmUrl
        webpUrl
        secondBanner
        createdAt
        updatedAt
        sections {
            id
            name
        }
    }
    totalCount
    }
}
`

export const getExplorePage = gql`
    query GetAdminExplores {
        getAdminExplores {
            aspectRatio
            createdAt
            id
            motionScore
            prompt
            style
            thumbnailUrl
            updatedAt
            gif
            category{
                name
                id
            }
            url
        }
    }
`
export const getExploreVideo = gql`
    query GetExploreVideo($exploreId: String!) {
        getExploreVideo(exploreId: $exploreId) {
            id
            url
            prompt
            thumbnailUrl
            motionScore
            style
            createdAt
            updatedAt
            aspectRatio
            gif
            categoryId
            category{
                name
                id
            }
        }
    }
`
export const getUserCreditHistory = gql`
    query GetUserCreditHistory($userId: String!) {
        getUserCreditHistory(userId: $userId) {
            id
            userId
            creditId
            amount
            transactionId
            sourceRcUserId
            destinationRcUserId
            type
            isPromo
            createdAt
            updatedAt
        }
    }
`
export const getUserCredits = gql`
    query GetUserCredits($userId: String!) {
        getUserCredits(userId: $userId) {
            id
            userId
            amount
            expiryDate
            rcEventId
            createdAt
            updatedAt
        }
    }
`
export const getCreditById = gql`
    query GetCreditById($creditId: String!) {
        getCreditById(creditId: $creditId) {
            id
            amount
            date
            createdAt
            updatedAt
            expiryDate
            rcEventId
            productName
            productType
            transactionId
            isPromo
            user {
                id
                email
            }
        }
    }
`

export const dashboardData = gql`
    query DashboardData {
        dashboardData {
            activeSubscriptions
            totalUser
            totalVideo
            modelCount
            dailyVideoCount {
                count
                date
            }
        }
    }
`

export const getToolUsageAnalytics = gql`
    query GetToolUsageAnalytics($startDate: String, $endDate: String, $limit: Int) {
        getToolUsageAnalytics(startDate: $startDate, endDate: $endDate, limit: $limit) {
            topPrompts {
                promptId
                promptName
                count
            }
            dailyPromptUsage {
                date
                count
            }
            promptUsageByDate {
                date
                prompts {
                    promptId
                    promptName
                    count
                }
            }
            totalUsageCount
            totalImageCount
        }
    }
`
export const getCategories = gql`
    query GetCategories {
        getCategories {
            id
            name
            video
            gif
            thumbnail
            description
            prompt
            model
            createdAt
            updatedAt
            type
            isExplore
        }
    }
`
export const getCategory = gql`
    query GetCategory($categoryId: String!) {
        getCategory(categoryId: $categoryId) {
            id
            name
            video
            gif
            thumbnail
            description
            prompt
            model
            createdAt
            updatedAt
            type
            isExplore
        }
    }
`


export const getAllSets = gql`
query GetAllSetsAdmin($status: String, $page: Int, $pageSize: Int, $type: String) {
    getAllSetsAdmin(status: $status, page: $page, pageSize: $pageSize, type: $type) {
        sets {
        id
        userId
        name
        status
        createdAt
        type
        images {
            url
        }
        videos {
            id
            thumbnailUrl
        }
        model {
            version
        }
        }
        totalCount
    }
}
`

export const getSet = gql`
    query GetUserSet($setId: String!) {
        getUserSet(setId: $setId) {
            id
            userId
            createdAt
            updatedAt
            name
            modelId
            prompts
            taskId
            type
            status
            images {
                url
            }
            model {
                version
            }
            videos {
                id
                url
                prompt
                thumbnailUrl
            }
            user {
                id
            }
        }
    }
`


export const getStyle = gql`
    query GetStyle($styleId: String!) {
        getStyle(styleId: $styleId) {
            id
            isFuture
            name
            banner
            designType
            rowNumber
            isPublic
            secondBanner
            videoUrl
            highlighted
            gifUrl
            webmUrl
            webpUrl
            toolType
            createdAt
            tags {
            id
            name
            }
            sections {
            id
            name
            }
            prompts {
            id
            prompt
            banner
            gender
            toolType
            }
            updatedAt
        }
    }
`
export const getAllPromptsAdmin = gql`
    query GetAllPromptsAdmin($pageSize: Int, $page: Int, $gender: Gender, $styleId: String, $toolType: ToolType, $name: String) {
        getAllPromptsAdmin(pageSize: $pageSize, page: $page, styleId: $styleId, gender:$gender, toolType: $toolType, name: $name){
        prompts{
            id
            name
            prompt
            banner
            videoUrl
            gifUrl
            webmUrl
            webpUrl
            designType
            toolType
            isVisible
            isPublic
            rowNumber
            createdAt
            updatedAt
            gender
            aspectRatio
            guidanceScale
            loraScale
            numInferenceSteps
            outputFormat
            outputQuality
            numOfOutPuts
            templateId
            inferanceModelEnum
            cost
}
            totalCount
        }
    }
`
export const getPrompt = gql`
    query GetPrompt($promptId: String!) {
        getPrompt(promptId: $promptId) {
            id
            prompt
            banner
            videoUrl
            gifUrl
            detailImage
            name
            webmUrl
            webpUrl
            designType
            toolType
            isVisible
            isPublic
            secondBanner
            rowNumber
            createdAt
            updatedAt
            gender
            aspectRatio
            guidanceScale
            loraScale
            intputImageCount
            numInferenceSteps
            outputFormat
            outputQuality
            beforeImage
            promptSvg
            highlighted
            inferanceModelEnum
            cost
            numOfOutPuts
            tags {
                id
                name
            }
            templateId
            toolRatios {
                id
                width
                height
                name
                aspectRatioX
                aspectRatioY
                createdAt
                updatedAt
            }
        }
    }
`
export const getAllModels = gql`
    query GetAllModelsAdmin($pageSize: Int, $page: Int, $name: String, $status: ReplicateStatusEnum) {
        getAllModelsAdmin(pageSize: $pageSize, page: $page, name: $name, status: $status) {
            models {
            id
            taskId
            version
            name
            image
            instanceData
            status
            createdAt
            updatedAt
            userId
            predict_time
            loraSafetensors
            triggerWord
            }
            totalCount
        }
    }
`

export const getModelData = gql`
    query GetModel($modelId: String!) {
        getModel(modelId: $modelId) {
            id
            taskId
            version
            name
            image
            instanceData
            status
            createdAt
            updatedAt
            userId
            predict_time
            loraSafetensors
            triggerWord
            sets {
                id
                name
                createdAt
            }
        }
    }
`



export const getAllSections = gql`
query GetAllSections {
  getAllSections {
    id
    name
    rowNumber
    designType
    isPublic
    banner
    videoUrl
    gifUrl
    webmUrl
    webpUrl
    createdAt
    updatedAt
    tools {
      id
      name
    }
    styles {
      id
      name
    }
  }
}
`

export const getSection = gql`
query GetSection($sectionId: String!) {
  getSection(sectionId: $sectionId) {
    id
    name
    rowNumber
    designType
    isPublic
    banner
    videoUrl
    gifUrl
    webmUrl
    webpUrl
    secondBanner
    createdAt
    updatedAt
    tools {
      id
      name
      banner
    }
    styles {
      id
      banner
      name
    }
      tags {
        id
        name
      }
  }
}
`


export const getHomePage = gql`
query GetHomePage($tagId: String) {
  getHomePage(tagId: $tagId) {
    home {
      ... on Section {
        id
        sectionName: name
        tools {
          id
          name
          beforeImage
          promptSvg
          banner
          videoUrl
          designType
        }
        styles {
          id
          name
          designType
          gifUrl
          videoUrl
          assets(tagId: $tagId) {
            banner
            videoUrl
            gifUrl
            webmUrl
            webpUrl
            designType
          }
          prompts {
            name
            assets(tagId: $tagId) {
              banner
              videoUrl
              designType
            }
          }
        }
        assets(tagId: $tagId) {
          banner
          videoUrl
          designType
        }
        orderAndHighlight(tagId: $tagId) {
          order
          highlighted
        }
      }
      ... on Style {
        id
        styleName: name
        prompts {
          banner
          id
          assets(tagId: $tagId) {
            banner
            videoUrl
            gifUrl
            webmUrl
            webpUrl
            designType
          }
        }
        assets(tagId: $tagId) {
          banner
          videoUrl
          designType
        }
        orderAndHighlight(tagId: $tagId) {
          order
          highlighted
        }
      }
      ... on Prompt {
        id
        promptName: name
        toolType
        assets(tagId: $tagId) {
          banner
          videoUrl
          designType
        }
        orderAndHighlight(tagId: $tagId) {
          order
          highlighted
        }
      }
    }
  }
}
`

export const getTag = gql`
query GetTag($tagId: String!) {
  getTag(tagId: $tagId) {
    id
    name
    isDefault
    createdAt
    updatedAt
  }
}
`

export const getAllTags = gql`
    query GetAllTags {
        getAllTags {
            id
            name
            createdAt
            updatedAt
        }
    }
`

export const getAllStylesForFilter = gql`
    query GetAllStylesForFilter {
        getAllStylesAdmin {
            styles {
                id
                name
            }
        }
    }
`

export const getAllSectionsForFilter = gql`
    query GetAllSectionsForFilter {
        getAllSections {
            id
            name
        }
    }
`

export const getAllExploreRows = gql`
    query GetAllExploreRows($tagId: String) {
        getAllExploreRows(tagId: $tagId) {
            id
            order
            isHighlighted
            contentId
            contentType
            platform
            tagId
            createdAt
            updatedAt
        }
    }
`

export const getExploreRowById = gql`
    query GetExploreRowById($id: String!) {
        getExploreRowById(id: $id) {
            id
            order
            isHighlighted
            contentId
            contentType
            platform
            tagId
            createdAt
            updatedAt
        }
    }
`

export const getExploreRowsByContentType = gql`
    query GetExploreRowsByContentType($contentType: ContentTypeEnum!) {
        getExploreRowsByContentType(contentType: $contentType) {
            id
            order
            isHighlighted
            contentId
            contentType
            platform
            tagId
            createdAt
            updatedAt
        }
    }
`

export const getHighlightedExploreRows = gql`
    query GetHighlightedExploreRows {
        getHighlightedExploreRows {
            id
            order
            isHighlighted
            contentId
            contentType
            platform
            tagId
            createdAt
            updatedAt
        }
    }
`

export const getExploreRowsByTag = gql`
    query GetExploreRowsByTag($tagId: String!) {
        getExploreRowsByTag(tagId: $tagId) {
            id
            order
            isHighlighted
            contentId
            contentType
            platform
            tagId
            createdAt
            updatedAt
        }
    }
`

export const getAllContent = gql`
    query GetAllContent($tagId: String, $sectionId: String, $styleId: String) {
        getAllContent(tagId: $tagId, sectionId: $sectionId, styleId: $styleId) {
            id
            contentId
            contentType
            videoUrl
            banner
            gifUrl
            designType
            tagId
            rowNumber
            sectionId
            styleId
            promptId
            createdAt
            updatedAt
            tag {
                id
                name
            }
            section {
                id
                name
            }
            style {
                id
                name
            }
            prompt {
                id
                name
            }
        }
    }
`

export const getContentById = gql`
    query GetContentById($id: String!) {
        getContentById(id: $id) {
            id
            contentId
            contentType
            videoUrl
            banner
            gifUrl
            webmUrl
            webpUrl
            secondBanner
            designType
            tagId
            rowNumber
            detailImage
            sectionId
            styleId
            promptId
            createdAt
            updatedAt
            tag {
                id
                name
            }
            section {
                id
                name
            }
            style {
                id
                name
            }
            prompt {
                id
                name
            }
        }
    }
`

export const getContentByType = gql`
    query GetContentByType($contentType: ContentTypeEnum!) {
        getContentByType(contentType: $contentType) {
            id
            contentId
            contentType
            videoUrl
            banner
            gifUrl
            webmUrl
            webpUrl
            secondBanner
            designType
            tagId
            detailImage
            rowNumber
            sectionId
            styleId
            promptId
            createdAt
            updatedAt
            tag {
                id
                name
            }
            section {
                id
                name
            }
            style {
                id
                name
            }
            prompt {
                id
                name
            }
        }
    }
`

export const getContentByDesignType = gql`
    query GetContentByDesignType($designType: StyleDesignEnum!) {
        getContentByDesignType(designType: $designType) {
            id
            contentId
            contentType
            videoUrl
            banner
            gifUrl
            designType
            tagId
            rowNumber
            detailImage
            sectionId
            styleId
            promptId
            createdAt
            updatedAt
            tag {
                id
                name
            }
            section {
                id
                name
            }
            style {
                id
                name
            }
            prompt {
                id
                name
            }
        }
    }
`

export const getAllSystemConfigs = gql`
    query GetAllSystemConfigs($page: Int, $pageSize: Int, $provider: ProviderEnum, $systemType: ToolType) {
        getAllSystemConfigs(page: $page, pageSize: $pageSize, provider: $provider, systemType: $systemType) {
            systemConfigs {
                id
                provider
                systemType
                systemModel
                createdAt
                updatedAt
            }
            totalCount
        }
    }
`

export const getSystemConfig = gql`
    query GetSystemConfig($id: String!) {
        getSystemConfig(id: $id) {
            id
            provider
            systemType
            systemModel
            createdAt
            updatedAt
        }
    }
`

export const getSystemConfigByTypeAndProvider = gql`
    query GetSystemConfigByTypeAndProvider($provider: ProviderEnum!, $systemType: ToolType!) {
        getSystemConfigByTypeAndProvider(provider: $provider, systemType: $systemType) {
            id
            provider
            systemType
            systemModel
            createdAt
            updatedAt
        }
    }
`

export const getContentByTag = gql`
    query GetContentByTag($tagId: String!) {
        getContentByTag(tagId: $tagId) {
            id
            contentId
            contentType
            videoUrl
            banner
            gifUrl
            webmUrl
            webpUrl
            secondBanner
            designType
            tagId
            rowNumber
            detailImage
            sectionId
            styleId
            promptId
            createdAt
            updatedAt
            tag {
                id
                name
            }
            section {
                id
                name
            }
            style {
                id
                name
            }
            prompt {
                id
                name
            }
        }
    }
`

export const getContentBySection = gql`
    query GetContentBySection($sectionId: String!) {
        getContentBySection(sectionId: $sectionId) {
            id
            contentId
            contentType
            videoUrl
            banner
            gifUrl
            designType
            tagId
            rowNumber
            sectionId
            styleId
            promptId
            createdAt
            updatedAt
            tag {
                id
                name
            }
            section {
                id
                name
            }
            style {
                id
                name
            }
            prompt {
                id
                name
            }
        }
    }
`

export const getContentByStyle = gql`
    query GetContentByStyle($styleId: String!) {
        getContentByStyle(styleId: $styleId) {
            id
            contentId
            contentType
            videoUrl
            banner
            gifUrl
            designType
            tagId
            rowNumber
            sectionId
            styleId
            promptId
            createdAt
            updatedAt
            tag {
                id
                name
            }
            section {
                id
                name
            }
            style {
                id
                name
            }
            prompt {
                id
                name
            }
        }
    }
`

export const getContentByPrompt = gql`
    query GetContentByPrompt($promptId: String!) {
        getContentByPrompt(promptId: $promptId) {
            id
            contentId
            contentType
            videoUrl
            banner
            gifUrl
            designType
            tagId
            rowNumber
            sectionId
            styleId
            promptId
            createdAt
            updatedAt
            tag {
                id
                name
            }
            section {
                id
                name
            }
            style {
                id
                name
            }
            prompt {
                id
                name
            }
        }
    }
`

export const getAllRevenueCatProducts = gql`
    query GetAllRevenueCatProducts($pagination: CreditProductPaginationInput, $filter: CreditProductFilterInput) {
        getAllCreditProducts(pagination: $pagination, filter: $filter) {
            items {
                id
                name
                amount
                startDate
                endDate
                limit
                price
                type
                createdAt
                updatedAt
            }
            total
            hasMore
        }
    }
`

export const getRevenueCatProductById = gql`
    query GetRevenueCatProductById($id: String!) {
        getCreditProductById(id: $id) {
            id
            name
            amount
            startDate
            endDate
            limit
            price
            type
            createdAt
            updatedAt
        }
    }
`

export const getActiveRevenueCatProducts = gql`
    query GetActiveRevenueCatProducts {
        getActiveCreditProducts {
            id
            name
            amount
            startDate
            endDate
            limit
            price
            type
            createdAt
            updatedAt
        }
    }
`

// ToolRatio Queries
export const getToolRatio = gql`
    query GetToolRatio($id: String!) {
        getToolRatio(id: $id) {
            id
            width
            height
            name
            aspectRatioX
            aspectRatioY
            toolId
            createdAt
            updatedAt
            tool {
                id
                name
            }
        }
    }
`

export const getToolRatios = gql`
    query GetToolRatios($toolId: String, $skip: Int, $take: Int) {
        getToolRatios(toolId: $toolId, skip: $skip, take: $take) {
            id
            width
            height
            name
            aspectRatioX
            aspectRatioY
            toolId
            createdAt
            updatedAt
            tool {
                id
                name
            }
        }
    }
`

export const getToolRatiosByTool = gql`
    query GetToolRatiosByTool($toolId: String!) {
        getToolRatiosByTool(toolId: $toolId) {
            id
            width
            height
            name
            aspectRatioX
            aspectRatioY
            createdAt
            updatedAt
        }
    }
`